/* ==========================================================================
   TIRZA THEME  ·  theme.js  (vanilla JS, no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.TirzaTheme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, 2800);
  }

  /* ---------- Money ---------- */
  function money(cents) {
    try {
      return new Intl.NumberFormat(cfg.locale || undefined, { style: 'currency', currency: cfg.currency || 'INR', maximumFractionDigits: (cents % 100 === 0) ? 0 : 2 }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  /* ---------- Mobile drawer ---------- */
  var drawer = $('[data-drawer]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
  }
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setDrawer(false); closeVideo(); }
  });

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var els = $$('.reveal:not(.is-in)', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Hero slider (fade) ---------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (root) {
      if (root.__tirza) return; root.__tirza = true;
      var slides = $$('[data-slide]', root);
      var dots = $$('[data-slider-dot]', root);
      var i = 0, timer = null;
      var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
      var auto = root.getAttribute('data-autoplay') === 'true';

      function go(n) {
        if (!slides.length) return;
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function start() { if (auto && slides.length > 1) { stop(); timer = setInterval(function () { go(i + 1); }, speed); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      var prev = $('[data-slider-prev]', root), next = $('[data-slider-next]', root);
      if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
      if (next) next.addEventListener('click', function () { go(i + 1); start(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slider-dot'), 10)); start(); }); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      // touch swipe
      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1));
        x0 = null; start();
      });

      // theme editor: jump to selected block
      root.addEventListener('shopify:block:select', function (e) { var idx = slides.indexOf(e.target); if (idx > -1) { stop(); go(idx); } });
      root.addEventListener('shopify:block:deselect', start);
      start();
    });
  }

  /* ---------- Horizontal scroller (review videos) ---------- */
  function initScrollers() {
    $$('[data-scroller]').forEach(function (root) {
      if (root.__tirza) return; root.__tirza = true;
      var track = $('[data-scroll-track]', root);
      if (!track) return;
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; }
      var p = $('[data-scroll-prev]', root), n = $('[data-scroll-next]', root);
      if (p) p.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      if (root.__tirza) return; root.__tirza = true;
      var btns = $$('[data-tab-btn]', root), panels = $$('[data-tab-panel]', root);
      function show(k) {
        btns.forEach(function (b) { var on = b.getAttribute('data-tab-btn') === k; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === k); });
        initReveal(root);
        $$('.reveal', root).forEach(function (e) { e.classList.add('is-in'); });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-tab-btn')); }); });
      root.addEventListener('shopify:block:select', function (e) {
        var panel = e.target.closest ? e.target.closest('[data-tab-panel]') || e.target : e.target;
        if (panel && panel.getAttribute && panel.getAttribute('data-tab-panel')) show(panel.getAttribute('data-tab-panel'));
      });
    });
  }

  /* ---------- Video modal (YouTube / Vimeo) ---------- */
  var modal = $('[data-video-modal]');
  var modalTarget = $('[data-video-target]');
  function openVideo(spec) {
    if (!modal || !modalTarget) return;
    var parts = spec.split(':'), type = parts[0], id = parts.slice(1).join(':');
    var src = type === 'vimeo'
      ? 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1'
      : 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
    modalTarget.innerHTML = '<iframe src="' + src + '" allow="autoplay; encrypted-media; fullscreen" allowfullscreen title="Customer review video"></iframe>';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeVideo() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    if (modalTarget) modalTarget.innerHTML = '';
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-video-embed]');
    if (b) { e.preventDefault(); openVideo(b.getAttribute('data-video-embed')); return; }
    if (e.target.closest && e.target.closest('[data-video-close]')) closeVideo();
    if (e.target === modal) closeVideo();
  });

  /* ---------- Cart ---------- */
  function refreshCartCount() {
    return fetch(cfg.cartJsUrl, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
        return cart;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-add], form[data-type="add-to-cart-form"]')) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    if (btn) { btn.disabled = true; }
    fetch(cfg.cartAddUrl + '.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || (cfg.strings && cfg.strings.error) || 'Error', true); return; }
        toast((cfg.strings && cfg.strings.added) || 'Added to your cart');
        return refreshCartCount();
      })
      .catch(function () { toast((cfg.strings && cfg.strings.error) || 'Error', true); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- Product page ---------- */
  function initProduct() {
    $$('[data-product]').forEach(function (root) {
      if (root.__tirza) return; root.__tirza = true;
      var jsonEl = $('[data-product-json]', root);
      if (!jsonEl) return;
      var product = JSON.parse(jsonEl.textContent);
      var idInput = $('[data-variant-id]', root);
      var addBtn = $('[data-add-btn]', root);
      var priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root);

      // gallery
      function showMedia(id) {
        $$('.pdp__slide', root).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id)); });
        $$('.pdp__thumb', root).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
      }
      $$('[data-thumb]', root).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });

      // variant picker
      function selected() {
        return $$('[data-option-index]', root).map(function (fs) {
          var c = $('input:checked', fs); return c ? c.value : null;
        });
      }
      function match(vals) {
        return product.variants.filter(function (v) {
          return vals.every(function (val, k) { return val === null || v.options[k] === val; });
        })[0];
      }
      function update() {
        var v = match(selected());
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = (cfg.strings && cfg.strings.soldOut) || 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) { priceEl.textContent = money(v.price); priceEl.classList.toggle('price--sale', v.compare_at_price > v.price); }
        if (compareEl) { compareEl.hidden = !(v.compare_at_price > v.price); compareEl.textContent = money(v.compare_at_price); }
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? ((cfg.strings && cfg.strings.addToCart) || 'Add to cart') : ((cfg.strings && cfg.strings.soldOut) || 'Sold out'); }
        if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
        try {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) { /* ignore */ }
      }
      $$('[data-option-index] input', root).forEach(function (i) { i.addEventListener('change', update); });

      // quantity
      var qty = $('[data-qty]', root);
      if (qty) {
        var input = $('input', qty);
        $('[data-qty-minus]', qty).addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
        $('[data-qty-plus]', qty).addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
      }
    });
  }

  /* ---------- Related products (recommendations) ---------- */
  function initRecs() {
    $$('[data-recs]').forEach(function (root) {
      if (root.__tirza) return; root.__tirza = true;
      var url = root.getAttribute('data-url');
      if (!url || /product_id=&/.test(url)) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-recs]', doc);
        if (fresh && fresh.innerHTML.trim() && $('.pcard', fresh)) { root.innerHTML = fresh.innerHTML; initReveal(root); $$('.reveal', root).forEach(function (e) { e.classList.add('is-in'); }); }
      }).catch(function () { /* silent */ });
    });
  }

  /* ---------- Collection filters / sort ---------- */
  function initFilters() {
    $$('[data-filter-form]').forEach(function (form) {
      if (form.__tirza) return; form.__tirza = true;
      var sort = $('[data-sort-select]', form);
      if (sort) sort.addEventListener('change', function () { form.submit(); });
    });
  }

  function initAll() {
    initReveal(document);
    initSliders(); initScrollers(); initTabs(); initProduct(); initRecs(); initFilters();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();

  // Theme editor re-render support
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
    initSliders(); initScrollers(); initTabs(); initProduct(); initRecs(); initFilters();
  });
})();
